import React from 'react';
import { MetaLayerDefinition, useLayers } from '@agissc/ktag-map';
import useAppState from '../../AppStore';
import LayerLegend from './LayerLegend';
import { WMSLayerDefinition, WMTSLayerDefinition } from '../../poc/Contracts';
import WmsLegend from './WmsLegend';
import GeoAdminLegend from './GeoAdminLegend';
import Scrollable from '../../components/scrollable/Scrollable';
import NoLegend from './NoLegend';
import LegendPlaceholder from './LegendPlaceholder';
import WmtsLegend from './WmtsLegend';

interface LegendContentProps {
  layer: MetaLayerDefinition;
}

const LegendContent = ({ layer }: LegendContentProps): React.JSX.Element | null => {
  const { id, url, source, properties, isPublic = true } = layer;
  if (url.includes('wmts.geo.admin.ch')) {
    if (layer.id === 'ch.swisstopo.swissimage::wms.geo.admin.ch') {
      return <WmtsLegend />;
    }
    return <GeoAdminLegend layerName={(properties as WMTSLayerDefinition).layername} />;
  }
  switch (source) {
    case 'topicmaps.geo.ag.ch':
      if (layer.type === 'wmts') {
        return <WmtsLegend />;
      }
      return url ? <LayerLegend topicId={id} url={url} isPublic={isPublic} /> : null;
    case 'wms.geo.ag.ch':
      return <WmsLegend layerName={(properties as WMSLayerDefinition).layernames} />;
    case 'wms.geo.admin.ch':
      if (layer.type === 'wmts') {
        return (
          <GeoAdminLegend layerName={(properties as WMTSLayerDefinition).layername} />
        );
      }

      return <GeoAdminLegend layerName={(properties as WMSLayerDefinition).layernames} />;

    default:
      return null;
  }
};

const Legend = () => {
  const layersQuery = useLayers();
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);
  const topicLayerSettings = useAppState((state) => state.topicLayerSettings);

  const selectedLayers = selectedTopicLayers.filter(
    (id) => topicLayerSettings[id].isVisible,
  );

  if (!selectedLayers.length) {
    return <NoLegend />;
  }

  if (layersQuery.isLoading) {
    return <LegendPlaceholder />;
  }

  const topicLayerResult = layersQuery.data ?? {};
  const topicLayers = selectedLayers
    .map((id) => topicLayerResult[id])
    .filter((item) => item);

  return (
    <Scrollable
      additionalClassName="tooldialog__wrapper-content"
      scrollAdditionClassName="tooldialog__wrapper-content--scrollable"
    >
      {topicLayers.map((topicLayer) => (
        <div key={`legend-${topicLayer.id}`} className="legend-group">
          <h3 className="legend__title">{topicLayer.title}</h3>
          <LegendContent layer={topicLayer} />
        </div>
      ))}
    </Scrollable>
  );
};

export default Legend;
